import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSidenav } from '@angular/material/sidenav';
import { Router } from '@angular/router';
import { GoogleAnalyticsService } from 'ngx-google-analytics';
import { Observable } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { DialogAcessoSimulado } from '../../components/dialogs/dialogs';
import { FirebaseRequestsService } from '../../services/requests/firebase/firebase-requests.service';
import { SecurityService } from './../../services/security.service';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
})
export class DashboardComponent implements OnInit {
  @ViewChild('drawer') drawer: MatSidenav;
  public appVersion = environment.appVersion;

  isHandset$: Observable<boolean> = this.breakpointObserver
    .observe(Breakpoints.Handset)
    .pipe(
      map((result) => result.matches),
      shareReplay()
    );

  constructor(
    private router: Router,
    private breakpointObserver: BreakpointObserver,
    public securityService: SecurityService,
    private $gaService: GoogleAnalyticsService,
    public fireReqs: FirebaseRequestsService,
    private dialog: MatDialog
  ) {}

  ngOnInit(): void {}

  openAcessoSimuladoModal() {
    this.dialog.open(DialogAcessoSimulado);
  }

  logout() {
    this.securityService.logout().then(() => {
      location.reload();
    });
  }
}
